// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dfdb0d71","455":"dc9f993a","977":"2caed02d"}[chunkId] + ".chunk.js";
};